import { useTranslation } from "react-i18next";

import { useMeta } from "@/features/home/api/useMeta";
import { Card, DefinitionList } from "@/shared/ui/Card";
import { ErrorState } from "@/shared/ui/ErrorState";
import { Skeleton } from "@/shared/ui/Skeleton";

export function HomePage() {
  const { t } = useTranslation();
  const { data, isPending, isError, error, refetch } = useMeta();

  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-3xl font-bold tracking-tight">{t("home.heading")}</h1>
        <p className="mt-2 max-w-prose text-slate-600 dark:text-slate-400">{t("home.intro")}</p>
      </header>

      <Card title={t("home.statusHeading")}>
        {isPending && (
          <div className="space-y-3">
            <Skeleton className="h-4 w-2/3" label={t("api.loading")} />
            <Skeleton className="h-4 w-1/2" label={t("api.loading")} />
          </div>
        )}

        {isError && <ErrorState error={error} onRetry={() => void refetch()} />}

        {data !== undefined && (
          <>
            <p className="mb-4 inline-flex items-center gap-2 text-sm font-medium text-green-700 dark:text-green-400">
              <span aria-hidden="true" className="size-2 rounded-full bg-green-600" />
              {t("api.reachable")}
            </p>
            <DefinitionList
              items={[
                { label: t("api.version"), value: data.version },
                { label: t("api.environment"), value: data.environment },
                { label: t("api.locales"), value: data.supported_locales.join(", ") },
              ]}
            />
          </>
        )}
      </Card>

      <Card title={t("home.roadmapHeading")}>
        <p className="text-sm text-slate-600 dark:text-slate-400">{t("home.roadmapBody")}</p>
      </Card>
    </div>
  );
}
